









































































import { Component, Vue } from "vue-property-decorator";
import CityService from "../services/city.service";

@Component({
  components: {},
})
export default class Outlets extends Vue {
  private service = new CityService();

  private outlets: any = [];

  private selectedoutlet = null;

  created() {
    this.service.getOutlets().then((res) => {
      this.outlets = res.data;
    });
  }
}
